export default "__VITE_ASSET__C$6l1Ms___"